import { render, staticRenderFns } from "./groupFitnessDashboardRatings.vue?vue&type=template&id=3d90053c&scoped=true"
import script from "./groupFitnessDashboardRatings.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardRatings.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardRatings.vue?vue&type=style&index=0&id=3d90053c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90053c",
  null
  
)

export default component.exports